import gql from 'graphql-tag'

export const GET_VEHICLE_VIDEO_TRACKERS_PAGINATION = gql`
  query PaginatedVideoTrackers($filter: GetVehicleVideoTrackersPaginatedInput) {
    paginatedVideoTrackers(filter: $filter) {
      isSuccessful
      message
      status
      paginatedVehicleVideoTrackers {
        data {
          vehicleId
          vehicle {
            id
            licensePlate
            imei
            hullNo
            vehicle2Vgroup {
              vgroup {
                name
              }
              vgroupId
            }
            device {
              deviceCode
              deviceName
              phoneNo
            }
            vehicleType {
              category
              manufacturer
              model
              type
              icon
            }
            driver1 {
              fullname
            }
          }
          companyId
          driverId
          motionStatus
          calculatedMotionStatus
          statusText
          videoStatus
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_VEHICLE_VIDEO_LIST = gql`
  query VehicleVideoTrackers($filter: GetVehicleVideoTrackersInput) {
    vehicleVideoTrackers(filter: $filter) {
      isSuccessful
      message
      vehicleVideoTrackers {
        vehicleId
        companyId
        driverId
        motionStatus
        calculatedMotionStatus
        streamingEndpoint
        lastReceive
        engineOn
        parent {
          vehicle {
            licensePlate
            driver1 {
              fullname
            }
          }
        }
        vehicle {
          id
          licensePlate
          imei
          hullNo
          vehicle2Vgroup {
            vgroup {
              name
            }
            vgroupId
          }
          device {
            deviceCode
            deviceName
            phoneNo
          }
          vehicleType {
            category
            manufacturer
            model
            type
            icon
            vehicleTypeId
          }
          driver1 {
            fullname
          }
        }
        statusText
      }
    }
  }
`

/**
 * Note : This query only used in page videoHistory3
 */
export const GET_VEHICLE_VIDEO_TRACKER_BY_VEHICLE_ID = gql`
  query VehicleVideoTrackers($filter: GetVehicleVideoTrackersInput) {
    vehicleVideoTrackers(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vehicleVideoTrackers {
        streamingEndpoint
        parent {
          vehicle {
            licensePlate
          }
        }
        vehicle {
          id
          imei
          licensePlate
          device {
            deviceCode
            deviceName
            timezone
            __typename
          }
          vehicleType {
            manufacturer
            model
            type
            category

            __typename
          }
          year
          hullNo
          __typename
        }
        statusText
      }
    }
  }
`

export const GET_VEHICLE_STATUS_TEXT = gql`
  query VehicleVideoTrackers($filter: GetVehicleVideoTrackersInput) {
    vehicleVideoTrackers(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vehicleVideoTrackers {
        statusText
        vehicleId
        vehicle {
          imei
          device {
            deviceCode
            deviceName
            __typename
          }
        }
      }
    }
  }
`

export const GET_SIGNED_URL = gql`
  query GetSignedUrl($filter: GetSignedUrlInput) {
    getSignedUrl(filter: $filter) {
      getSignedUrl {
        url
      }
    }
  }
`

export const GET_VEHICLE_VIDEO_FILTER = gql`
  query VehicleVideoTrackers($filter: GetVehicleVideoTrackersInput) {
    vehicleVideoTrackers(filter: $filter) {
      vehicleVideoTrackers {
        vehicleId
        parent {
          vehicle {
            licensePlate
          }
        }
        vehicle {
          id
          licensePlate
          imei
          status
          vehicleType {
            category
            manufacturer
            model
            type
            icon
          }
          vehicle2Vgroup {
            vgroupId
            vgroup {
              name
            }
          }
        }
        statusText
      }
    }
  }
`

export const GET_VEHICLE_VIDEO_TRACKERS_VIDEO_HISTORY = gql`
  query VehicleVideoTrackers($filter: GetVehicleVideoTrackersInput) {
    vehicleVideoTrackers(filter: $filter) {
      vehicleVideoTrackers {
        vehicleId
        calculatedMotionStatus
        lastReceive
        engineOn
        vehicle {
          id
          licensePlate
          imei
          status
          device {
            deviceCode
            deviceName
            timezone
          }
          vehicleType {
            category
            manufacturer
            model
            type
            icon
            vehicleTypeId
          }
          vehicle2Vgroup {
            vgroupId
            vgroup {
              name
            }
          }
        }
        statusText
      }
    }
  }
`

export const GET_VEHICLE_TV_DATA = gql`
  query Vehicle($filter: GetVehicleFilter!) {
    vehicle(filter: $filter) {
      isSuccessful
      message
      vehicle {
        id
        imei
        licensePlate
        device {
          deviceCode
          deviceName
        }
        children {
          id
          imei
          device {
            deviceCode
          }
        }
      }
    }
  }
`
